import React from 'react';
import venueData from '../../data/venue.json';

export default function VenueSection() {
    return (
        <section id="venue" className="bsides-venue">
            <style>{`
                .bsides-venue {
                    background: var(--eventflow-black);
                    padding: 100px 0 0;
                    position: relative;
                    overflow: hidden;
                }
                .bsides-venue::before {
                    content: '';
                    position: absolute;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: radial-gradient(ellipse at 30% 50%, rgba(var(--eventflow-base-rgb),0.07) 0%, transparent 55%);
                    pointer-events: none;
                }

                /* info cards row */
                .venue-info-row {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 16px;
                    margin-bottom: 48px;
                }
                .venue-info-card {
                    background: rgba(var(--eventflow-white-rgb),0.03);
                    border: 1px solid rgba(var(--eventflow-white-rgb),0.08);
                    border-radius: 12px;
                    padding: 24px 20px;
                    display: flex;
                    align-items: flex-start;
                    gap: 14px;
                    transition: border-color 0.3s, background 0.3s;
                }
                .venue-info-card:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.35);
                    background: rgba(var(--eventflow-base-rgb),0.04);
                }
                .venue-info-card__icon {
                    width: 40px; height: 40px;
                    border-radius: 8px;
                    background: rgba(var(--eventflow-base-rgb),0.12);
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0;
                }
                .venue-info-card__icon i { font-size: 16px; color: var(--eventflow-base); }
                .venue-info-card__label {
                    font-family: var(--eventflow-font);
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    color: rgba(var(--eventflow-white-rgb),0.4);
                    margin-bottom: 4px;
                }
                .venue-info-card__value {
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    font-weight: 600;
                    color: var(--eventflow-white);
                    line-height: 1.4;
                }

                /* map */
                .venue-map-wrap {
                    position: relative;
                    border-radius: 16px;
                    overflow: hidden;
                    border: 1px solid rgba(var(--eventflow-white-rgb),0.08);
                    box-shadow: 0 30px 80px rgba(0,0,0,0.5);
                    margin-bottom: 0;
                }
                .venue-map-wrap iframe {
                    width: 100%;
                    height: 420px;
                    display: block;
                    filter: invert(90%) hue-rotate(180deg) saturate(0.8) brightness(0.85);
                    border: none;
                }
                .venue-map-overlay {
                    position: absolute;
                    top: 20px; left: 20px;
                    background: rgba(4,0,10,0.85);
                    backdrop-filter: blur(12px);
                    border: 1px solid rgba(var(--eventflow-white-rgb),0.1);
                    border-radius: 12px;
                    padding: 16px 20px;
                    max-width: 280px;
                }
                .venue-map-overlay h4 {
                    font-family: var(--eventflow-font);
                    font-size: 15px;
                    font-weight: 700;
                    color: var(--eventflow-white);
                    margin-bottom: 4px;
                }
                .venue-map-overlay p {
                    font-family: var(--eventflow-font);
                    font-size: 12px;
                    color: rgba(var(--eventflow-white-rgb),0.5);
                    margin-bottom: 12px;
                    line-height: 1.5;
                }

                /* how to reach */
                .venue-reach {
                    background: rgba(var(--eventflow-white-rgb),0.02);
                    border-top: 1px solid rgba(var(--eventflow-white-rgb),0.06);
                    padding: 60px 0;
                    margin-top: 0;
                }
                .venue-reach-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 24px;
                }
                .venue-reach-item {
                    text-align: center;
                }
                .venue-reach-item__icon {
                    width: 56px; height: 56px;
                    border-radius: 50%;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto 16px;
                    transition: background 0.3s, border-color 0.3s;
                }
                .venue-reach-item:hover .venue-reach-item__icon {
                    background: rgba(var(--eventflow-base-rgb),0.2);
                    border-color: rgba(var(--eventflow-base-rgb),0.5);
                }
                .venue-reach-item__icon i { font-size: 20px; color: var(--eventflow-base); }
                .venue-reach-item__title {
                    font-family: var(--eventflow-font);
                    font-size: 15px;
                    font-weight: 700;
                    color: var(--eventflow-white);
                    margin-bottom: 8px;
                }
                .venue-reach-item__desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    line-height: 1.6;
                    color: rgba(var(--eventflow-white-rgb),0.45);
                    margin: 0;
                }

                @media (max-width: 991px) {
                    .venue-info-row { grid-template-columns: repeat(2,1fr); }
                    .venue-reach-grid { grid-template-columns: repeat(2,1fr); }
                }
                @media (max-width: 576px) {
                    .venue-info-row { grid-template-columns: 1fr; }
                    .venue-reach-grid { grid-template-columns: 1fr; }
                    .venue-map-wrap iframe { height: 280px; }
                    .venue-map-overlay { max-width: 200px; }
                }
            `}</style>

            <div className="container">
                {/* Header */}
                <div className="text-center mb-5 wow fadeInUp" data-wow-delay="100ms">
                    <div className="bsides-section-tag" style={{justifyContent:'center'}}>Event Venue</div>
                    <h2 className="bsides-section-title" style={{textAlign:'center'}}>{venueData.name}</h2>
                    <p style={{color:'rgba(255,255,255,0.5)',fontSize:'15px',maxWidth:'500px',margin:'0 auto'}}>{venueData.address}</p>
                </div>

                {/* Info cards */}
                <div className="venue-info-row wow fadeInUp" data-wow-delay="150ms">
                    <div className="venue-info-card">
                        <div className="venue-info-card__icon"><i className="fa fa-map-marker-alt" /></div>
                        <div><div className="venue-info-card__label">Location</div><div className="venue-info-card__value">Coimbatore, Tamil Nadu</div></div>
                    </div>
                    <div className="venue-info-card">
                        <div className="venue-info-card__icon"><i className="fa fa-calendar-alt" /></div>
                        <div><div className="venue-info-card__label">Date</div><div className="venue-info-card__value">{venueData.date}</div></div>
                    </div>
                    <div className="venue-info-card">
                        <div className="venue-info-card__icon"><i className="fa fa-clock" /></div>
                        <div><div className="venue-info-card__label">Timing</div><div className="venue-info-card__value">{venueData.time}</div></div>
                    </div>
                    <div className="venue-info-card">
                        <div className="venue-info-card__icon"><i className="fa fa-users" /></div>
                        <div><div className="venue-info-card__label">Capacity</div><div className="venue-info-card__value">{venueData.capacity}</div></div>
                    </div>
                </div>

                {/* Map */}
                <div className="venue-map-wrap wow fadeInUp" data-wow-delay="200ms">
                    <iframe
                        title="Venue Map"
                        src={venueData.mapEmbed}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                    <div className="venue-map-overlay">
                        <h4>{venueData.name}</h4>
                        <p>{venueData.address}</p>
                        <a
                            href={venueData.mapsLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="thm-btn"
                            style={{fontSize:'13px', padding:'8px 16px 8px 20px'}}
                        >
                            Get Directions <span className="icon-arrow-right" />
                        </a>
                    </div>
                </div>
            </div>

            {/* How to reach */}
            <div className="venue-reach">
                <div className="container">
                    <div className="text-center mb-5 wow fadeInUp" data-wow-delay="100ms">
                        <div className="bsides-section-tag" style={{justifyContent:'center'}}>Getting Here</div>
                        <h3 style={{fontFamily:'var(--eventflow-font)',fontSize:'32px',fontWeight:'800',color:'var(--eventflow-white)'}}>How to Reach the Venue</h3>
                    </div>
                    <div className="venue-reach-grid wow fadeInUp" data-wow-delay="200ms">
                        {venueData.howToReach.map((item, i) => (
                            <div className="venue-reach-item" key={i}>
                                <div className="venue-reach-item__icon"><i className={`fa ${item.icon}`} /></div>
                                <div className="venue-reach-item__title">{item.title}</div>
                                <p className="venue-reach-item__desc">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
